import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import HubSpotFeature from './FormComponents/HubSpotFeature';

export const FormFeature: React.FC<Content.Form> = ({ content }) => {
	const dictionary = useDictionaryContext();
	const kicker = {
		firstWord: content.properties.kickerFirstWord,
		secondWord: content.properties.kickerSecondWord,
	};

	return (
		<HubSpotFeature
			documentType="form"
			content={content}
			kicker={kicker}
			selectAllLabel={dictionary?.getValue('Form.SelectAllFormLabel')}
			placeholderLabel={dictionary?.getValue('Form.PlaceholderLabel')}
		/>
	);
};
